export const TOGGLE_ROWS = [
  {
    key: 'importantNotes',
    title: 'Important notes to buyers',
    description: '',
  },
  {
    key: 'externalLinks',
    title: 'External Links',
    description: '',
  },
  {
    key: 'requestDeliveryDetails',
    title: 'Request delivery details',
    description: 'Buyers will be asked to provide their delivery address when ordering.',
  },
];
